import { Tooltip, TooltipProps, withStyles } from '@material-ui/core';
import React from 'react';

export const TitleTooltip = withStyles({
    tooltip: {
        backgroundColor: '#FFFFFF',
        color: '#000000',
        border: '1px solid #000000',
        boxShadow: 'none',
        fontSize: 13,
        padding: 8,
        maxWidth: 300,
    },
})(Tooltip);

export default function ControledTooltip({ children, ...props }: React.PropsWithChildren<TooltipProps>) {
    return (
        <TitleTooltip interactive {...props}>
            {children}
        </TitleTooltip>
    );
}
